import React from 'react';
import {Link} from 'react-router-dom';


import './aboutsection.styles.css'


const AboutSection = props => {
   
    return(
    <section className="section-about">
    <div className="u-center-text u-margin-bottom-big">
        <h2 className="heading-secondary">
            Planinarski Klub Greben 
        </h2>
    </div>

    <div className="row">
        <div className="col-1-of-2">
            <h3 className="heading-tertiary u-margin-bottom-small">Da Se Predstavimo</h3>
            <p className="paragraph o-nama-mainp">
            Klub je osnovan aprila 2012, i do sada je organizovao preko 350 planinarskih akcija kako u zemlji tako i u inostranstvu. 
            </p>            
            <p className="paragraph o-nama-mainp">
            Osvojeni Vrhovi: U Himalajima Island peak (6189m.);  na Kavkazu Zapadni Elbrus (5642m.) koji je naviši vrh Evropskog kontinenta i Rusije (2013. i 2016.godine); Kilimandžaro (5895m.) najviši vrh Afričkog kontinenta, Tanzanije i Kenije(2018); u Alpima Mont Blanc (4810m.) najviši vrh Evropske unije,Francuske i Italije (2012, 2014, 2015 i 2016.godine); Damavand (5671m.) najviši stratovulkan Azije, koji je ujedno i najviši vrh Irana (2016.godine); kao i najviše vrhove, Austrije, Slovenije, Balkana…
            </p>

            <Link to="/aboutus" className="btn-text">Saznaj više &rarr;</Link>
        </div>
        <div className="col-1-of-2">
            <div className="composition">

                <img srcSet={`${props.images[0]}.jpg 300w, ${props.images[0]}-large.jpg 1000w`}
                     sizes="(max-width: 56.25em) 20vw, (max-width: 37.5em) 30vw, 300px"
                     alt="Photo 1"
                     className="composition__photo composition__photo--p1"
                     src= {`${props.images[0]}-large.jpg`} />


                <img srcSet={`${props.images[1]}.jpg 300w, ${props.images[1]}-large.jpg 1000w`}
                     sizes="(max-width: 56.25em) 20vw, (max-width: 37.5em) 30vw, 300px"
                     alt="Photo 2"
                     className="composition__photo composition__photo--p2"
                     src= {`${props.images[1]}-large.jpg`} />

                <img srcSet={`${props.images[2]}.jpg 300w, ${props.images[2]}-large.jpg 1000w`}
                     sizes="(max-width: 56.25em) 20vw, (max-width: 37.5em) 30vw, 300px"
                     alt="Photo 3"
                     className="composition__photo composition__photo--p3"
                     src= {`${props.images[2]}-large.jpg`} />


                {/* <!--
                <img src="img/nat-1-large.jpg" alt="Photo 1" className="composition__photo composition__photo--p1">
                <img src="img/nat-2-large.jpg" alt="Photo 2" className="composition__photo composition__photo--p2">
                <img src="img/nat-3-large.jpg" alt="Photo 3" className="composition__photo composition__photo--p3">
                --> */}
            </div>
        </div>
    </div>
</section>
)};


export default AboutSection;